/*
======================================================
Shopify Price format function usage:
Shopify.formatMoney(YOUR PRICE, window.moneyFormat);
======================================================
*/

if (typeof Shopify === "undefined") {
  Shopify = {};
}
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function (cents, format) {
    var value = "",
      placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
      formatString = format || this.money_format;
    if (typeof cents == "string") {
      cents = cents.replace(".", "");
    }
    function defaultOption(opt, def) {
      return typeof opt == "undefined" ? def : opt;
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ",");
      decimal = defaultOption(decimal, ".");

      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100.0).toFixed(precision);

      var parts = number.split("."),
        dollars = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          "$1" + thousands
        ),
        cents = parts[1] ? decimal + parts[1] : "";

      return dollars + cents;
    }
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
    }
    var finalString = formatString.replace(placeholderRegex, value);
    finalString = finalString.replace(/['"]+/g, "");
    return finalString;
  };
}

$(function () {
  /*
   =======================================
  	****placed custom javascript here. ***
   =======================================
   */

  //home page main slider
  homeSlideShowSlider();

  //home page scrollable image slider
  homeScrollableImgSlider();

  //home page Testimonial slider
  homeTestimonialSlider();

  //product page main image slider
  productImagesSlider();

  //home page compare section
  $(".compare-table-mbtab a").each(function () {
    $(this).on("click", function (e) {
      e.preventDefault();
      var dataId = $(this).attr("data-id");
      $(".compare-table-mbtab a").removeClass("active");
      $(".compare-table-col").removeClass("active");
      $(this).addClass("active");
      $("." + dataId).addClass("active");
    });
  });

  //product page Advanced Package section JS
  if ($("body.template--product .practice-plan").length > 0 || $('body.template--product .product .main-plans-box-wrapper').length ) {
    var _inputChecked = $(
      $(
        "body.template--product .practice-plan .plan-wrapper .plans-block input:checked"
      )
    );
    
    var _hasMembership =  $('.product .main-plans-box-wrapper').length > 0 ? true : _inputChecked.closest(".plans-block").hasClass("has-membership");
    if (_hasMembership == true) {
      if ($("body.template--product .advance-package").length > 0) {
        if (
          $("body.template--product .advance-package").hasClass(
            "hide-section"
          ) == false
        ) {
          // $("body.template--product .advance-package").removeClass("hidden");
        } else {
          $("body.template--product .advance-package").attr(
            "has-hide-class",
            "hide-section"
          );
          // $("body.template--product .advance-package")
          //   .removeClass("hidden")
          //   .removeClass("hide-section");
        }
      }
    } else {
      //$("body.template--product .advance-package").addClass("hidden");
      $("body.template--product .advance-package.hide-section").removeClass(
        "hide-section"
      );
    }
  }

  //home page specialized section, collection page specialized section
  $(document).on(
    "click",
    ".specialized-dropdown .specialized-drop-default",
    function (e) {
      e.preventDefault();
      $(this).toggleClass("active");
    }
  );
  $(document).on(
    "click",
    ".specialized-dropdown .specialized-drop-prod li",
    function (e) {
      e.preventDefault();      
      if( $(this).closest('.membership-drop-prod').length > 0 ){ 
        return false;
      } else {
        console.log('asd');
        var dataVal = $(this).attr("data-value"),
          titleText = $(this).text().trim();
        if (dataVal == "default") {
          $(".specialized-dropdown .specialized-drop-default").removeClass(
            "active"
          );
        } else {
          $(".detail-accourdian .specialized-dropdown .specialized-drop-default")
            .attr("data-value", dataVal)
            .text(titleText)
            .removeClass("active");
          $(
            ".main-collection-dropdown .specialized-dropdown .specialized-drop-default"
          )
            .attr("data-value", dataVal)
            .text(titleText)
            .removeClass("active");
          $(
            ".specialized-products .specialized-dropdown .specialized-drop-default"
          )
            .attr("data-value", dataVal)
            .text(titleText)
            .removeClass("active");
          //show product based on selected li data-value
          var gridCounter = 0;
          $(
            ".specialized-pro-grid .specialized-pro-col, #product-grid .collection-specialized-grid, #product-grid .filter_grid"
          ).each(function () {
            var pdTagVal = $(this).attr("data-tags"),
              pdPoplarLabelTag = $(this).attr("data-popluar-enable");
            $(this).addClass("hidden");
            $(this).find(".speciality-metafield").addClass("hidden");
            $(this).find(".speciality-shop-metaField").addClass("hidden");
            $(".specialized-pro-grid-wrap").removeClass("active-shadow");
  
            var pdTagValArry = $(this).attr("data-tags").split(",");
            for (let i = 0; i < pdTagValArry.length; i++) {
              if (pdTagValArry[i] == dataVal) {
                gridCounter += 1;
                //home page specialized section dropdown
                $(
                  '.specialized-pro-grid .specialized-pro-col[data-tags="' +
                    pdTagVal +
                    '"]'
                ).removeClass("hidden");
                $(
                  '.specialized-pro-grid .specialized-pro-col[data-tags="' +
                    pdTagVal +
                    '"] .speciality-metafield[data-tags="' +
                    dataVal +
                    '"]'
                ).removeClass("hidden");
                $(
                  '.specialized-pro-grid .specialized-pro-col[data-tags="' +
                    pdTagVal +
                    '"] .specialized-recommendation-text'
                ).html("<strong><span>" + titleText + "</strong></span>");
  
                //default-collection page dropdown
                $(
                  '#product-grid .collection-specialized-grid[data-tags="' +
                    pdTagVal +
                    '"]'
                ).removeClass("hidden");
                $(
                  '#product-grid .collection-specialized-grid[data-tags="' +
                    pdTagVal +
                    '"] .card-product-short-desc'
                ).addClass("hidden");
                $(
                  '#product-grid .collection-specialized-grid[data-tags="' +
                    pdTagVal +
                    '"] .application-metafield'
                ).addClass("hidden");
                $(
                  '#product-grid .collection-specialized-grid[data-tags="' +
                    pdTagVal +
                    '"] .specialized-recommendation-text'
                ).removeClass("hidden");
                $(
                  '#product-grid .collection-specialized-grid[data-tags="' +
                    pdTagVal +
                    '"] .speciality-shop-metaField[data-tags="' +
                    dataVal +
                    '"]'
                ).removeClass("hidden");
                $(
                  '#product-grid .collection-specialized-grid[data-tags="' +
                    pdTagVal +
                    '"] .specialized-recommendation-text'
                ).html("<strong><span>" + titleText + "</strong></span>");
  
                //filter-colletion template
                $(this)
                  .closest(".filters-no-active")
                  .removeClass("filters-no-active");
                $(
                  '#product-grid .filter_grid[data-tags="' + pdTagVal + '"]'
                ).removeClass("hidden");
                $(
                  '#product-grid .filter_grid[data-tags="' +
                    pdTagVal +
                    '"] .card-product-short-desc'
                ).addClass("hidden");
                $(
                  '#product-grid .filter_grid[data-tags="' +
                    pdTagVal +
                    '"] .application-metafield'
                ).addClass("hidden");
                $(
                  '#product-grid .filter_grid[data-tags="' +
                    pdTagVal +
                    '"] .recommendation-desc'
                ).removeClass("hidden");
                $(
                  '#product-grid .filter_grid[data-tags="' +
                    pdTagVal +
                    '"] .speciality-shop-metaField[data-tags="' +
                    dataVal +
                    '"]'
                ).removeClass("hidden");
                $(
                  '#product-grid .filter_grid[data-tags="' +
                    pdTagVal +
                    '"] .specialized-recommendation-text'
                ).html("<strong><span>For " + titleText + "</strong></span>");
              }
            }
  
            //For mostPopular label logic for all section
            $(this).removeClass("popular");
            $(this).find(".card-product-tag").addClass("hidden");
            var pdTagLabelArry =
              $(this).attr("data-popluar-enable").split(",") || null;
            if (pdTagLabelArry) {
              for (let i = 0; i < pdTagLabelArry.length; i++) {
                if (pdTagLabelArry[i] == dataVal) {
                  //home page specialized section dropdown
                  $(
                    '.specialized-pro-grid .specialized-pro-col[data-popluar-enable="' +
                      pdPoplarLabelTag +
                      '"]'
                  ).addClass("popular");
                  $(
                    '.specialized-pro-grid .specialized-pro-col[data-popluar-enable="' +
                      pdPoplarLabelTag +
                      '"] .card-product-tag'
                  ).removeClass("hidden");
  
                  //default-collection page dropdown
                  $(
                    '#product-grid .collection-specialized-grid[data-popluar-enable="' +
                      pdPoplarLabelTag +
                      '"]'
                  ).addClass("popular");
                  $(
                    '#product-grid .collection-specialized-grid[data-popluar-enable="' +
                      pdPoplarLabelTag +
                      '"] .card-product-tag'
                  ).removeClass("hidden");
  
                  //filter-colletion template
                  $(
                    '#product-grid .filter_grid[data-popluar-enable="' +
                      pdPoplarLabelTag +
                      '"]'
                  ).addClass("popular");
                  $(
                    '#product-grid .filter_grid[data-popluar-enable="' +
                      pdPoplarLabelTag +
                      '"] .card-product-tag'
                  ).removeClass("hidden");
                }
              }
            }
  
            //home page
            //$('.specialized-pro-grid .specialized-pro-col[data-tags="'+dataVal+'"]').removeClass('hidden');
  
            //default-collection
            //$('#product-grid .collection-specialized-grid[data-tags="'+dataVal+'"]').removeClass('hidden');
            //$('#product-grid .collection-specialized-grid[data-tags="'+dataVal+'"] .card-product-short-desc').addClass('hidden');
            //$('#product-grid .collection-specialized-grid[data-tags="'+dataVal+'"] .specialized-recommendation-text').removeClass('hidden');
            //$('#product-grid .collection-specialized-grid[data-tags="'+dataVal+'"] .speciality-shop-metaField').removeClass('hidden');
  
            //filter-colletion template
            //$(this).closest('.filters-no-active').removeClass('filters-no-active');
            //$('#product-grid .filter_grid[data-tags="'+dataVal+'"]').removeClass('hidden');
            //$('#product-grid .filter_grid[data-tags="'+dataVal+'"] .card-product-short-desc').addClass('hidden');
            //$('#product-grid .filter_grid[data-tags="'+dataVal+'"] .recommendation-desc').removeClass('hidden');
          });
  
          //Add class if filter grid result is lessthan 3
          if (gridCounter < 3) {
            $(".specialized-pro-grid-wrap .specialized-pro-grid").addClass(
              "two-down-box"
            );
            $(".main-collection-product-grid #product-grid").addClass(
              "two-down-box"
            );
          } else {
            $(".specialized-pro-grid-wrap .specialized-pro-grid").removeClass(
              "two-down-box"
            );
            $(".main-collection-product-grid #product-grid").removeClass(
              "two-down-box"
            );
          }
          gridCounter > 3
            ? $(".specialized-pro-grid-wrap").addClass("grater-three")
            : $(".specialized-pro-grid-wrap").removeClass("grater-three");
  
          //filter-colletion template top product bar
          $(".filters-box-list .filters-box-col").each(function () {
            $(this).removeClass("active");
            var pdTagVal = $(this).attr("data-tags");
            var pdTagValArry = pdTagVal.split(",");
            for (let i = 0; i < pdTagValArry.length; i++) {
              if (pdTagValArry[i] == dataVal) {
                $(
                  '.filters-box-list .filters-box-col[data-tags="' +
                    pdTagVal +
                    '"]'
                ).addClass("active");
              }
            }
          });

          $('.package-item').addClass('hidden');
          if($('.package-item[data-name="'+dataVal+'"]').length > 0){
            $('.package-item[data-name="'+dataVal+'"]').each(function(ele,item){
              $(item).removeClass('hidden');
            })
            $('.advance-package').removeClass('hidden');  
          }else{
            $('.advance-package').addClass('hidden');
          }
        }
      }
    }
  );

  $(document).click(function (event) {
    if (
      !$(event.target).is(".specialized-dropdown .specialized-drop-default")
    ) {
      $(".specialized-dropdown .specialized-drop-default").removeClass(
        "active"
      );
    }
  });

  //on dropdown li click store value in localstorage
  $(".store_val").on("click", function () {
    var store_val_tag = $(this).attr("data-value");
    localStorage.setItem("speciality", store_val_tag);
  });
  //END--on dropdown li click store value in localstorage

  //filter-colletion template
  $(".filters-box-list .filters-box-col").on("click", function () {
    var link = $(this).attr("data-href");
    let hightCalc = 0;
    $(".filters-box-list").hasClass("banner-sticky")
      ? (hightCalc =
          $(".filters-box-list.banner-sticky").outerHeight() +
          $("header").outerHeight())
      : (hightCalc = $("header").outerHeight() + 10);
    $("html, body").animate(
      {
        scrollTop: $(link).offset().top - hightCalc,
      },
      1000
    );
  });

  //END--specialized section filter, collection page specialized section

  //product page pratice plan dropdown
  $(document).on(
    "click",
    ".plans-block .specialized-dropdown .membership-drop-prod li, .main-plans-box-wrapper .specialized-dropdown .membership-drop-prod li",
    function (e) {
      e.preventDefault();
      let dataValId = $(this).attr("data-id"),
        dataValPrice = $(this).attr("data-price"),
        dataValSellingPlanId = $(this).attr("data-selling-plan"),
        titleText = $(this).text().trim();
      $(".plans-block .specialized-dropdown .specialized-drop-default")
        .attr("data-id", dataValId)
        .attr("data-price", dataValPrice)
        .attr("data-selling-plan", dataValSellingPlanId)
        .text(titleText)
        .removeClass("active");
      if( $(this).closest('.main-plans-box-wrapper').length > 0 ){
        titleText = $(this).find('.p-name').text().trim();
        var titlePrice = $(this).find('.price').html();
        $(this).siblings('.selected').removeClass('selected');
        $(this).addClass('selected');
        $(".main-plans-box-wrapper .specialized-dropdown .specialized-drop-default")
          .attr("data-id", dataValId)
          .attr("data-price", dataValPrice)
          .attr("data-selling-plan", dataValSellingPlanId)        
          .removeClass("active");
        $(".main-plans-box-wrapper .specialized-dropdown .specialized-drop-default").find('.p-name').text(titleText);
        $(".main-plans-box-wrapper .specialized-dropdown .specialized-drop-default").find('.price').empty().append(titlePrice);
        var _year = Number(($(this).attr('data-value')).split('-')[1]);
        _year = _year == 1 ? ' year' : (_year+' years')
        $("#clarius-membership-main-popups .price-wrapper .price-item").empty().append(`${titlePrice} / ${_year}`);
      }
    }
  );
  //END - product page pratice plan dropdown

  $(document).click(
    debounce(function (event) {
      if ($("body.template--product").length > 0) {
        if ($(event.target).closest(".product__info-wrapper")) {
          var _product = $(event.target).closest(".product__info-wrapper");

          if (
            $(event.target).closest("#recommendation-popup") ||
            $(event.target).closest(".package-popup-content")
          ) {
            var _product = $(event.target)
              .closest("body.template--product")
              .find(".product .product__info-wrapper");
          }

          if (
            $(_product).find(
              ".package-list .package-item .package-price-wrapper .add-membership input[type=checkbox]:checked"
            ).length > 0
          ) {
            $(_product)
              .find(".product-navigation ul li[data-nav-packages]")
              .addClass("active");
          } else {
            $(_product)
              .find(".product-navigation ul li[data-nav-packages]")
              .removeClass("active");
          }

          if (
            $(_product).find(
              ".accessories-list .item-price-wrapper input.warranty-input-wrap:checked"
            ).length > 0
          ) {
            $(_product)
              .find(".product-navigation ul li[data-nav-accessories]")
              .addClass("active");
          } else {
            $(_product)
              .find(".product-navigation ul li[data-nav-accessories]")
              .removeClass("active");
          }

          if (
            $(_product).find(
              ".warranty-care-wrapper .warranty-item input[type=radio]:checked"
            ).length > 0
          ) {
            $(_product)
              .find(".product-navigation ul li[data-nav-clariuscare]")
              .addClass("active");
          } else {
            $(_product)
              .find(".product-navigation ul li[data-nav-clariuscare]")
              .removeClass("active");
          }

          /*var _liLength = $(_product).find('.product-navigation ul li').length - 1, _liLength2 = 0, _activeLi2 = 0, _activeLi = $(_product).find('.product-navigation ul li.active:not([data-nav-addtocart])').length;
        _activeLi2 =  $(_product).find('.product-navigation ul li[data-nav-plan]').length > 0 ? 2 : 1;
        $(_product).find('.product-navigation ul li.active').each(function(){
          if( $(this).attr('data-nav-plan') != undefined || $(this).attr('data-nav-clariuscare') != undefined ){
            _liLength2 = _liLength2 + 1;
          } });
        
        if( _activeLi > 0 && ( _activeLi >= _liLength || _liLength2 >= _activeLi2 ) ){
          $(_product).find('.product-navigation ul li[data-nav-addtocart]').addClass('active')
        }else{
          $(_product).find('.product-navigation ul li[data-nav-addtocart]').removeClass('active')
        }*/
        }
      }
    }, 369)
  );

  //home page bottom sticky bar
  $(window).scroll(function () {
    var windowpos = $(window).scrollTop();
    var heightCalc,
      divHeight = 0;
    $(".specialized-pro-grid-wrap").hasClass("grater-three")
      ? (divHeight = 3000)
      : (divHeight = 1830);
    $(".specialized-pro-grid-wrap").hasClass("active-shadow")
      ? (heightCalc = 1085)
      : (heightCalc = divHeight);
    if ($(window).width() < 750) {
      $(".specialized-pro-grid-wrap").hasClass("grater-three")
        ? (divHeight = 3500)
        : (divHeight = 1350);
      //$('.specialized-pro-grid').hasClass('two-down-box') ? divHeight = 1850 : divHeight = 1330;
      $(".specialized-pro-grid-wrap").hasClass("active-shadow")
        ? (heightCalc = 760)
        : (heightCalc = divHeight);
    }
    windowpos >= heightCalc
      ? $(".shopify-section.sticky-bar").addClass("sticky")
      : $(".shopify-section.sticky-bar").removeClass("sticky");

    //collection page add class to filter
    if ($(".template--collection-filters").length > 0) {
      let hederHight = $("header").outerHeight();
      let otherSectionHieght = $(".filters-collection-banner").outerHeight();
      let otherSection1Hieght =
        $(
          ".filters-collection-product-grid .main-collection-dropdown"
        ).outerHeight() + 20;
      windowpos >= hederHight + otherSectionHieght + otherSection1Hieght
        ? $(".filters-box-list.banner-sticky").addClass("banner-sticky-active")
        : $(".filters-box-list.banner-sticky").removeClass(
            "banner-sticky-active"
          );
    }
    //end - collection page add class to filter
  });
  $(document).on("click", ".sticky-bar.sticky a", function (e) {
    e.preventDefault();
    $("html, body").animate(
      {
        scrollTop: $(".specialized-products").offset().top - 40,
      },
      1000
    );
  });
  //END

  //faq section remove hide class
  if ($(".faq-main-wrapper .faq-block .accordion-container .set").length > 0) {
    $(".faq-main-wrapper").removeClass("hide");
  }

  //image section remove hide class
  if (
    $(
      '.scrollable-image-slider-product .scrollable-image-slider .slick-slide:not(".slick-cloned")'
    ).length > 0
  ) {
    $(".scrollable-image-slider-product").removeClass("hide");
  }

  $(".set > a").on("click", function () {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).siblings(".set-content").slideUp(200);
      $(".set > a i").removeClass("fa-minus").addClass("fa-plus");
    } else {
      $(".set > a i").removeClass("fa-minus").addClass("fa-plus");
      $(this).find("i").removeClass("fa-plus").addClass("fa-minus");
      $(".set > a").removeClass("active");
      $(this).addClass("active");
      $(".set-content").slideUp(200);
      $(this).siblings(".set-content").slideDown(200);
    }
  });

  $(".package-item .info").on("click", function () {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).siblings(".package-content-wrapper").slideUp(200);
      $(".package-item .info i").removeClass("fa-minus").addClass("fa-plus");
    } else {
      $(".package-item .info i").removeClass("fa-minus").addClass("fa-plus");
      $(this).find("i").removeClass("fa-plus").addClass("fa-minus");
      $(".package-item .info").removeClass("active");
      $(this).addClass("active");
      $(".package-content-wrapper").slideUp(200);
      $(this).siblings(".package-content-wrapper").slideDown(200);
    }
  });

  $(".accessories-list").slick({
    dots: false,
    infinite: false,
    speed: 400,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $(".popup-with-move-anim").magnificPopup({
    type: "inline",
    preloader: false,
    focus: "#username",
    modal: true,
    removalDelay: 300,
    closeOnBgClick: true,
    mainClass: "my-mfp-zoom-in",
    callbacks: {
      open: function () {
        $("body").addClass("mg_modal_popup_true");
      },
      elementParse: function (item) {
        // Function will fire for each target element
        // "item.el" is a target DOM element (if present)
        // "item.src" is a source that you may modify
        var _item = item.el[0];
        var _id = $(_item).attr("href");
        //console.log('Parsing content. Item object that is being parsed:', $(_item), $(_item).closest('.package-item'));

        if (_id == "#recommendation-popup") {
          var _dataID = $("#recommendation-popup")
            .find(".add-product-btn")
            .attr("data-id");
          var _inputWarr = $(
            '.accessories-list .item-price-wrapper input.warranty-input-wrap[data-id="' +
              _dataID +
              '"][data-recomnded-product="true"]'
          );
          $(this).removeClass("btnChecked");
          $(this).text($(this).attr("data-text"));
          if ($(_inputWarr).prop("checked") == true) {
            $(_inputWarr).prop("checked", true);
            $(this).addClass("btnChecked");
            $(this).text($(this).attr("data-text-added"));
          }
        }

        if ($(_item).closest(".package-item").length > 0) {
          if (
            $(_item)
              .closest(".package-item")
              .find(".package-price-wrapper .add-membership input")
              .prop("checked") == true
          ) {
            var _text = $(item.src)
              .find(".select-package-btn")
              .attr("data-text-active");
            $(item.src)
              .find(".select-package-btn")
              .text(_text)
              .addClass("packageSelected");
          } else {
            var _text = $(item.src)
              .find(".select-package-btn")
              .attr("data-text");
            $(item.src)
              .find(".select-package-btn")
              .text(_text)
              .removeClass("packageSelected");
          }
        }
        if ($(_item).closest(".package-item").length > 0) {
          if (
            $(_item)
              .closest(".package-item")
              .find(".package-price-wrapper .add-membership input")
              .prop("checked") == true
          ) {
            var _text = $(item.src)
              .find(".select-package-btn")
              .attr("data-text-active");
            $(item.src)
              .find(".select-package-btn")
              .text(_text)
              .addClass("packageSelected");
          } else {
            var _text = $(item.src)
              .find(".select-package-btn")
              .attr("data-text");
            $(item.src)
              .find(".select-package-btn")
              .text(_text)
              .removeClass("packageSelected");
          }
        }
      },
      afterClose: function () {
        $("body").removeClass("mg_modal_popup_true");
      },
    },
  });

  $(document).on("click", ".popup-modal-dismiss", function (e) {
    e.preventDefault();
    $.magnificPopup.close();
  });
  $(document).on("click", "body.mg_modal_popup_true", function (e) {
    if (
      $(e.target).closest(".mid-size-popup").length == 0 &&
      $(".mfp-wrap.mfp-ready").length > 0
    ) {
      $.magnificPopup.close();
    }
  });

  $(document).on(
    "click",
    ".package-popup-content .select-package-btn:not(.packageSelected)",
    function (e) {
      e.preventDefault();
      var _inputId = "#" + $(this).attr("data-input");
      $(_inputId).prop("checked", true);
      $.magnificPopup.close();
    }
  );
  $(document).on(
    "click",
    ".recommendation-popup-content .reco-product .pro-item .add-product-btn",
    function (e) {
      e.preventDefault();
      var _dataID = $(this).attr("data-id");
      var _inputWarr = $(
        '.accessories-list .item-price-wrapper input.warranty-input-wrap[data-id="' +
          _dataID +
          '"][data-recomnded-product="true"]'
      );
      if ($(_inputWarr).prop("checked") == true) {
      } else {
        $(_inputWarr).prop("checked", true);
        $(this).addClass("btnChecked");
        $(this).text($(this).attr("data-text-added"));
      }
      $.magnificPopup.close();
    }
  );

  //on load set addtocart price
   if (
    $(".practice-plan .warranty-input-wrap:checked")
      .closest(".plans-block")
      .find(".plan-details .plan-price .price").length > 0 ||
    $(".main-plans-box-wrapper .plan-price-slogan [data-totalplan]").length > 0
  ) {
    var before_curr_price;
    if( $(".main-plans-box-wrapper .plan-price-slogan [data-totalplan]").length > 0 ){
      before_curr_price = $(".main-plans-box-wrapper .plan-price-slogan [data-totalplan]").attr("data-totalplan");
    }else{
      before_curr_price = $(".practice-plan .warranty-input-wrap:checked")
      .closest(".plans-block")
      .find(".plan-details .plan-price .price")
      .attr("data-totalplan");
    }
   if( $('.main-plans-box-wrapper .specialized-dropdown .specialized-drop-default .price').length > 0 ){
     $("#clarius-membership-main-popups .price-wrapper .price-item").empty().append(`${$('.main-plans-box-wrapper .specialized-dropdown .specialized-drop-default .price').html()} / year`);
   }
    calculatePrice(before_curr_price, false);
  }

  //on Billing option change set addtocart price
  $(document).on("change", ".plan-details .billing-cycle select", function () {
    var _val = $(this).val(),
      _price = $(this)
        .find('option[value="' + _val + '"]')
        .attr("data-price");
    var _format_price = Shopify.formatMoney(_price, window.moneyFormat);
    $(".plan-details .plan-price-wrapper small .suboptions_price")
      .empty()
      .text(_format_price);
    $(".plan-details .plan-price-wrapper small .suboptions_price").attr(
      "data-plan-money",
      _price
    );
    $(".stikey-add-to-cart .plan-detail .inner_price_wrap")
      .empty()
      .text(_format_price);
    var merged_plan_price =
      parseFloat(
        $(".plan-details .plan-price-wrapper .plan-price .price").attr(
          "data-plan-money"
        )
      ) + parseFloat(_price);
    $(
      ".has-membership .plan-details .plan-price-wrapper .plan-price .price"
    ).attr("data-totalplan", merged_plan_price);

    var curr_price = $(".practice-plan .warranty-input-wrap:checked")
      .closest(".plans-block")
      .find(".plan-details .plan-price .price")
      .attr("data-totalplan");
    if (
      $(".practice-plan .warranty-input-wrap:checked")
        .closest(".plans-block")
        .hasClass("has-membership")
    ) {
      calculatePrice(curr_price, false);
    } else if ( $(".main-plans-box-wrapper").length > 0 ){
      curr_price = $(".main-plans-box-wrapper .plan-price-slogan [data-totalplan]").attr("data-totalplan");
      calculatePrice(curr_price, false);
    } else {
      calculatePrice(curr_price, true);
    }
  });
  //on Billing option ul li click addtocart price
  $(document).on(
    "click",
    '.plan-details [data-name="billing-cycle"] .select ul li, .main-plans-box-wrapper .specialized-dropdown .select .membership-drop-prod li',
    function () {      
      var _price = $(this).attr("data-price");
      var _title = $(this).attr("data-item-title");
      var _format_price = Shopify.formatMoney(_price, window.moneyFormat);
      if(document.querySelector('.shop-pay-price').classList.contains('active')){
        document.querySelector('.shop-pay-price').classList.remove('active');  
      }
      if(_title == 'One time'){
        document.querySelector('.shop-pay-price').classList.add('active');
      }
      var dataItemTitleText = $(this).attr("data-item-title");
      $(".plan-details .plan-price-wrapper small .suboptions_price, .main-plans-box-wrapper .plan-price-slogan .suboptions_price")
        .empty()
        .text(_format_price)
        .attr("data-plan-money", _price);
      // $(".plan-details .plan-price-wrapper small .membership-text, .main-plans-box-wrapper .plan-price-slogan .membership-text")
      //   .empty()
      //   .text(dataItemTitleText.replace("1", "") + " " + "membership:");
      $(".plan-details .plan-price-wrapper small .membership-text, .main-plans-box-wrapper .plan-price-slogan .membership-text")
        .empty()
        .text(dataItemTitleText + " " + "membership");
      $(".stikey-add-to-cart .plan-detail .inner_price_wrap")
        .empty()
        .text(_format_price + " " + dataItemTitleText + " membership");
      var merged_plan_price =
        parseFloat(
          $(".plan-details .plan-price-wrapper .plan-price .price, .plan-price-slogan strong[data-totalplan]").attr(
            "data-plan-money"
          )
        ) + parseFloat(_price);
      $(
        ".has-membership .plan-details .plan-price-wrapper .plan-price .price, .plan-price-slogan strong[data-totalplan]"
      ).attr("data-totalplan", merged_plan_price);

      var curr_price = $(".practice-plan .warranty-input-wrap:checked")
        .closest(".plans-block")
        .find(".plan-details .plan-price .price")
        .attr("data-totalplan");
      if (
        $(".practice-plan .warranty-input-wrap:checked")
          .closest(".plans-block")
          .hasClass("has-membership")
      ){        
        calculatePrice(curr_price, false);
      } else if ( $(".main-plans-box-wrapper").length > 0) {
        curr_price = $('.main-plans-box-wrapper .plan-price-slogan strong[data-totalplan]').attr("data-totalplan");
        calculatePrice(curr_price, false);
      } else {
        calculatePrice(curr_price, true);
      }
    }
  );

  //on Practice option change set addtocart price
  $(document).on(
    "change",
    ".pro-select-advance-filter .plan-wrapper .plans-block input[type=radio]",
    function () {
      var curr_price = $(this)
        .closest(".plans-block")
        .find(".plan-details .plan-price-wrapper .plan-price .price")
        .attr("data-totalplan");
      if ($(this).closest(".plans-block").hasClass("has-membership")) {
        $(".advance-package .package-list").addClass("active");
        var oldTitltText = $(".advance-package .block-title").attr(
          "data-title-text"
        );
        $(".advance-package .block-title").text(oldTitltText);
        $(".advance-package .sub-texts").removeClass("hidden");
        $(".advance-package .package-list .package-item").each(function () {
          $(this)
            .find(".package-price-wrapper .add-membership input")
            .prop("checked", true);
        });
        calculatePrice(curr_price, false);
        $(".plan-detail").removeClass("hide");
        // if (
        //   $(this)
        //     .closest(".pro-select-advance-filter")
        //     .find(".advance-package")
        //     .hasClass("hide-section") == false
        // ) {
        //   $(".advance-package").removeClass("hidden");
        // }
      } else {
        // $(".advance-package").addClass("hidden");
        // if (
        //   $(this)
        //     .closest(".pro-select-advance-filter")
        //     .find(".advance-package")
        //     .hasClass("hide-section")
        // ) {
        //   $(".advance-package").addClass("hidden");
        // }
        $(".advance-package .package-list").removeClass("active");
        $(".advance-package .block-title").text(
          "Select Your Advanced Specialty Package"
        );
        $(".advance-package .sub-texts").addClass("hidden");
        $(".advance-package .package-list .package-item").each(function () {
          $(this)
            .find(".package-price-wrapper .add-membership input")
            .prop("checked", false);
        });
        calculatePrice(curr_price, true);
        $(".plan-detail").addClass("hide");
      }
    }
  );

  //on Packages option change set addtocart price
  $(document).on(
    "click",
    ".advance-package .package-item .package-price-wrapper .add-membership .warranty-input-wrap",
    function () {
      var curr_price = $(".practice-plan .warranty-input-wrap:checked")
        .closest(".plans-block")
        .find(".plan-details .plan-price .price")
        .attr("data-totalplan");
      if (
        $(".practice-plan .warranty-input-wrap:checked")
          .closest(".plans-block")
          .hasClass("has-membership")
      ) {
        calculatePrice(curr_price, false);
      } else if ( $(".main-plans-box-wrapper").length > 0 ){
        curr_price = $(".main-plans-box-wrapper .plan-price-slogan [data-totalplan]").attr("data-totalplan");
        calculatePrice(curr_price, false);
      } else {
        calculatePrice(curr_price, true);
      }
    }
  );

  //on Accessories option change set addtocart price
  $(document).on(
    "click",
    ".add-accessories .accessories-list .list-item .item-price-wrapper .warranty-input-wrap",
    function () {
      var curr_price = $(".practice-plan .warranty-input-wrap:checked")
        .closest(".plans-block")
        .find(".plan-details .plan-price .price")
        .attr("data-totalplan");
      if (
        $(".practice-plan .warranty-input-wrap:checked")
          .closest(".plans-block")
          .hasClass("has-membership")
      ) {
        calculatePrice(curr_price, false);
      } else if ( $(".main-plans-box-wrapper").length > 0 ){
        curr_price = $(".main-plans-box-wrapper .plan-price-slogan [data-totalplan]").attr("data-totalplan");
        calculatePrice(curr_price, false);
      } else {
        calculatePrice(curr_price, true);
      }
    }
  );

  //on Warranty option change set addtocart price
  $(document).on("change", ".warranty-item input", function () {
    $(".product__info-container .extended-warranty .error-msg").remove(); //remove error msg if any
    $(".warranty-care-wrapper").removeClass("error-active"); //remove error class if has
    var curr_price = $(".practice-plan .warranty-input-wrap:checked")
      .closest(".plans-block")
      .find(".plan-details .plan-price .price")
      .attr("data-totalplan");
    if (
      $(".practice-plan .warranty-input-wrap:checked")
        .closest(".plans-block")
        .hasClass("has-membership")
    ) {
      calculatePrice(curr_price, false);
    } else if ( $(".main-plans-box-wrapper").length > 0 ){
      curr_price = $(".main-plans-box-wrapper .plan-price-slogan [data-totalplan]").attr("data-totalplan");
      calculatePrice(curr_price, false);
    } else {
      calculatePrice(curr_price, true);
    }
  });

  //product page addToCart button price change function
  function calculatePrice(productprice, subscription_Val) {
    var mergedPrice = parseFloat(productprice);
    if (subscription_Val == true) {
      $(".advance-package .package-list .package-item").each(function () {
        if (
          $(this)
            .find(".package-price-wrapper .add-membership .warranty-input-wrap")
            .is(":checked")
        ) {
          mergedPrice =
            mergedPrice +
            parseFloat(
              $(this)
                .find(
                  ".package-price-wrapper .add-membership .warranty-input-wrap"
                )
                .attr("data-price")
            );
        }
      });
    }

    $(".add-accessories .accessories-list .list-item").each(function () {
      if (
        $(this)
          .find(".item-price-wrapper .select-item .warranty-input-wrap")
          .is(":checked")
      ) {
        mergedPrice =
          mergedPrice +
          parseFloat(
            $(this)
              .find(".item-price-wrapper .select-item .warranty-input-wrap")
              .attr("data-price")
          );
      }
    });

    if ($(".warranty-care-wrapper .warranty-item input:checked").length > 0) {
      mergedPrice =
        mergedPrice +
        parseFloat(
          $(".warranty-care-wrapper .warranty-item input:checked").attr(
            "data-price"
          )
        );
    }

    $(".product-form .product-form__submit .update_value").attr(
      "data-price-obj",
      mergedPrice
    );
    $(".product-form .product-form__submit .update_value").text(
      Shopify.formatMoney(mergedPrice, window.moneyFormat)
    );
    document.querySelector('.plan-price').textContent = Shopify.formatMoney(mergedPrice, window.moneyFormat);
    $(".stikey-add-cart .btn-price").text(
      Shopify.formatMoney(mergedPrice, window.moneyFormat)
    );
  }

  //trigger main addToCart button
  $(document).on("click", ".stikey-add-cart", function (e) {
    e.preventDefault();
    let recomndedPopEl =
      $(
        '.product__info-container .add-accessories .accessories-list .list-item input[name="accessories"][data-recomnded-product="true"]'
      ) || null;
    let counterPopupBtn =
      $(
        'body .product-popup-section-container a[href="#recommendation-popup"]'
      ) || null;
    let counterPopup = Number(counterPopupBtn.attr("data-counter")) || 0;
    if (
      recomndedPopEl.length > 0 &&
      counterPopupBtn.length > 0 &&
      recomndedPopEl.is(":checked") == false &&
      counterPopup == 0
    ) {
      $(
        'body .product-popup-section-container a[href="#recommendation-popup"]'
      ).trigger("click");
      $(
        'body .product-popup-section-container a[href="#recommendation-popup"]'
      ).attr("data-counter", 1);
      console.log("recomnded product not added---");
      return;
    } else {
      $(this).addClass("loading").attr("aria-disabled", true);
      $(this).find(".loading-overlay__spinner").removeClass("hidden");
      $(".product-form .product-form__submit").trigger("click"); //trigger main addToCart button
    }
  });

  //check if user checked T&C on cart page
  // $(document).on('click','[name="checkout"]', function(e){
  //   var isInputChecked = $('.cart__footer .additional-text input[type="checkbox"]').is(':checked');
  //   if(isInputChecked == false){
  //     e.preventDefault();
  //     if(!$('.cart__footer .additional-text .error-msg').length){
  //       $('.cart__footer .additional-text').append('<p class="error-msg">This field is required</p>');
  //       $('html, body').animate({ scrollTop: ($('.additional-text').offset().top - 100)}, 500);
  //     }
  //   }
  // });
});

$(document).on("click", ".special-link", function () {
  var handle = $(this).attr("data-handle");
  localStorage.setItem("speciality", handle);
});

$(window).on("resize", function () {
  var currentUserScreenWidth = screen.width;
  $(".slideshow__slider.slick-initialized").slick("refresh");
  //$('.scrollable-image-slider.top-slider.slick-initialized, .scrollable-image-slider.bottom-slider.slick-initialized').slick('refresh');
  $(".testimonial-slider.slick-initialized").slick("refresh");
});

$(window).scroll(
  debounce(function (event) {
    var _scrollTop = $(this).scrollTop();
    if ($("body.template--product").length && $(".stikey-add-to-cart").length) {
      var aTCBtn =
        $(".product-form__buttons .product-form__submit").offset().top - 100;
      var aTCBtnTop = $(".shopify-section-header-sticky").outerHeight(true);
      if (window.innerWidth > 640) {
        $(".stikey-add-to-cart").css("top", aTCBtnTop + "px");
      } else {
        $(".stikey-add-to-cart").css("top", " ");
      }
      //console.log('scrollTop',_scrollTop, aTCBtn);
      if (_scrollTop >= aTCBtn) {
        $(".stikey-add-to-cart").addClass("open");
      } else {
        $(".stikey-add-to-cart").removeClass("open");
      }
    }
  }, 150)
);

function homeSlideShowSlider() {
  var autoPlay =
    $(".slideshow-home .slideshow__slider").attr("data-autoplay") == "true"
      ? true
      : false;
  var autoPlaySpeed = parseInt(
    $(".slideshow-home .slideshow__slider").attr("data-autoplay-speed")
  );
  var arrowShow =
    $(".slideshow-home .slideshow__slider").attr("data-arrow-show") == "true"
      ? true
      : false;
  $(".slideshow__slider").slick({
    infinite: true,
    arrows: Boolean(arrowShow),
    speed: 700,
    autoplay: Boolean(autoPlay),
    autoplaySpeed: autoPlaySpeed,
    fade: true,
  });
}

function homeScrollableImgSlider() {
  if ($(".scrollable-image-slider.slick-initialized").length > 0) {
    return;
  }

  var slickOption = {
    speed: 5000,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: "linear",
    slidesToScroll: 1,
    slidesToShow: 4,
    arrows: true,
    infinite: false,
    swipe: false,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          centerPadding: "100px",
        },
      },
      {
        breakpoint: 992,
        settings: {
          centerPadding: "70px",
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 750,
        settings: {
          centerPadding: "30px",
          slidesToShow: 1,
          arrows: true,
        },
      },
    ],
  };
  var slickOptionTem = slickOption;
  var _tempspeed = 0,
    sliderInterval;

  if (
    $(
      '.scrollable-image-slider.bottom-slider:not(.slick-initialized)[dir="rtl"]'
    ).length
  ) {
    slickOptionTem.rtl = true;
    $(".scrollable-image-slider.bottom-slider:not(.slick-initialized)").slick(
      slickOptionTem
    );
    slickOption.rtl = false;
  } else {
    $(".scrollable-image-slider.bottom-slider:not(.slick-initialized)").slick(
      slickOption
    );
  }

  if (
    $(".scrollable-image-slider.top-slider").attr("data-slidestoshow") !=
    undefined
  ) {
    slickOption.slidesToShow = Number(
      $(".scrollable-image-slider.top-slider").attr("data-slidestoshow") || 3
    );
  }
  if (
    $(".scrollable-image-slider.top-slider").attr("data-infinite") != undefined
  ) {
    slickOption.infinite = Boolean(
      $(".scrollable-image-slider.top-slider").attr("data-infinite") || "true"
    );
  }
  $(".scrollable-image-slider.top-slider:not(.slick-initialized)").slick(
    slickOption
  );
  $(
    ".scrollable-image-slider.top-slider, .scrollable-image-slider.bottom-slider"
  ).attr("data-speed", slickOption.speed);

  $(
    ".scrollable-image-slider.bottom-slider, .scrollable-image-slider.top-slider"
  ).on("afterChange", function (event, slick, currentSlide) {
    var _slider = slick.$slider;
    if (!$(_slider).hasClass("stopAutoPlay")) {
      if (
        $($(slick.$slides)[slick.$slides.length - 1]).hasClass("slick-active")
      ) {
        var lastSliclAcive =
          Number(
            $($(slick.$slides)[slick.$slides.length - 1]).attr(
              "data-slick-index"
            )
          ) || 0;
        //console.log(lastSliclAcive + 1, slick.$slides.length, ( lastSliclAcive + 1 ) == slick.$slides.length);
        //alert(lastSliclAcive + 1, slick.$slides.length, ( lastSliclAcive + 1 ) == slick.$slides.length);
        if (lastSliclAcive + 1 == slick.$slides.length) {
          if (
            $(_slider).attr("data-infinite") != undefined &&
            $(_slider).attr("data-infinite") == "true"
          ) {
          } else {
            $(_slider).slick("slickPause");
            setTimeout(function () {
              slickRevesr(slick);
            }, 150);
          }
        }
      }
    }

    /*var _currentActive = Number($($(_slider).find('.slick-active')[0]).attr('data-slick-index'));
    var _currentSlide = currentSlide - 1;
    if( $(_slider).hasClass('slick-reverseCycle') && _currentActive != 0 ){      
      setTimeout(function(){ $(_slider).slick('slickGoTo',Number(_currentSlide));
                           },250);
    }*/
  });

  function slickRevesr(slick) {
    var _slider = slick.$slider;
    if ($(_slider).hasClass("called")) return;
    /*setTimeout(function(){$(_slider).slick('slickPause');},300);*/
    $(_slider).addClass("called");
    var _transform = $(slick.$slideTrack).css("transform");
    _transform = Number(
      _transform.split("(")[1].replace(")", "").split(", ")[4]
    );
    var slickTransform = 0,
      sCount = 0;
    $(slick.$slides).each(function (index, item) {
      if (!$(item).hasClass("slick-active")) {
        slickTransform += $(item).outerWidth(true);
      }
      if ($(item).hasClass("slick-current")) {
        $(item).removeClass("slick-current");
        $(item).attr("tabindex", "0").attr("aria-hidden", "true");
      }
      if ($(item).hasClass("slick-active")) {
        $(item).removeClass("slick-active");
        $(item).attr("tabindex", "0").attr("aria-hidden", "true");
        sCount = sCount + 1;
      }
    });

    var _dirRtl = false,
      _condition = _transform < 0;
    if (_slider.attr("dir") == "rtl") {
      _dirRtl = true;
      _condition = _transform > 0;
    }

    if (_condition) {
      _tempspeed = Number($(_slider).attr("data-speed"));
      $(_slider).find(".slick-arrow").addClass("slick-reverse");

      var _slidesToShow = slick.originalSettings.slidesToShow;
      if (
        slick.activeBreakpoint != null &&
        slick.breakpointSettings[slick.activeBreakpoint].slidesToShow !=
          undefined
      ) {
        _slidesToShow =
          slick.breakpointSettings[slick.activeBreakpoint].slidesToShow;
      }

      /*  var _currentSlide = slick.currentSlide - 1; _currentSlide = _currentSlide <= 0 ? 0 : _currentSlide; console.log('slick ',slick.currentSlide, _currentSlide);$(_slider).addClass('slick-reverseCycle'); setTimeout(function(){ $(_slider).slick('slickGoTo',Number(_currentSlide)); },1);*/

      var _tempspeed1 = _tempspeed * (slick.slideCount - _slidesToShow);
      setTimeout(function () {
        $(slick.$slideTrack).animate(
          { left: _dirRtl ? "-" + slickTransform : slickTransform },
          _tempspeed1,
          "linear",
          function () {
            $(slick.$slides).each(function (index, item) {
              if (index == 0) {
                $(item).addClass("slick-current slick-active");
                $(item).attr("tabindex", "0").attr("aria-hidden", "false");
              }
              if (index > 0 && index < sCount) {
                $(item).addClass("slick-active");
                $(item).attr("tabindex", "0").attr("aria-hidden", "false");
              } else {
                $(item).attr("tabindex", "-1").attr("aria-hidden", "true");
              }
            });
            setTimeout(function () {
              $(slick.$slideTrack).css("left", "");
              $(slick.$slideTrack).css(
                "transform",
                "translate3d(0px, 0px, 0px)"
              );
              slick.currentLeft = slick.currentLeft + slickTransform;
              $(_slider).slick("slickSetOption", "speed", _tempspeed);
              slick.currentSlide = 0;
              slick.direction = 1;
              $(_slider).slick("slickPlay");
              $(_slider).find(".slick-arrow").removeClass("slick-reverse");
              $(_slider).removeClass("called");
              return false;
            }, 100);
          }
        );
        //_reverseSliderCalled = setInterval(function(){ reveserSlidercount(slick) }, _tempspeed);
      }, 100);
    }
    return false;
  }

  function reveserSlidercount(slick) {
    //console.log('slick.currentSlide ',slick.currentSlide );
    var _current = slick.currentSlide;
    _current = _current - 1;
    _current = _current <= 0 ? 0 : _current;
    slick.currentSlide = _current - 1;
    //console.log('slick.currentSlide ',slick.currentSlide,' _current ',_current );
    if (_current >= 0 && _current < 2) {
      clearInterval(_reverseSliderCalled);
    }
  }

  $(document).on(
    "click",
    ".scrollable-image-slider .slick-arrow",
    function (e) {
      e.preventDefault();
      var _this = $(this);
      //console.log('sliderInterval ',sliderInterval );
      if (sliderInterval != undefined) {
        clearInterval(sliderInterval);
      }

      var _slider = $(this).closest(".slick-initialized");
      var _slick = $(_slider)[0].slick;
      $(_slider).addClass("stopAutoPlay");
      if (!$(this).hasClass("slick-reverse")) {
        sliderDisable();

        if ($(this).hasClass("slick-disabled")) {
          var _slidesToShow = _slick.originalSettings.slidesToShow;
          if (
            _slick.activeBreakpoint != null &&
            _slick.breakpointSettings[_slick.activeBreakpoint].slidesToShow !=
              undefined
          ) {
            _slidesToShow =
              _slick.breakpointSettings[_slick.activeBreakpoint].slidesToShow;
          }

          var nextSlider = _slick.slideCount - _slidesToShow;
          //console.log( nextSlider,_slidesToShow);
          if ($(this).hasClass("slick-prev")) {
            $(_slider).slick("slickGoTo", nextSlider);
          }
          if ($(this).hasClass("slick-next")) {
            $(_slider).slick("slickGoTo", 0);
          }
        }
      } else {
        $(_slick.$slideTrack).stop().css("left", "");
        $(_slider).find(".slick-arrow").removeClass("slick-reverse");
        $(_slider).removeClass("called");
        sliderDisable();
      }

      function sliderDisable() {
        setTimeout(function () {
          if (!_this.hasClass("clicked")) {
            _this
              .closest(".scrollable-image-slider")
              .find(".slick-arrow")
              .addClass("clicked");
            $(_slider).slick("slickPause");
            $(_slider).slick("slickSetOption", "waitForAnimate", false);
            $(_slider).slick("slickSetOption", "useCSS", false);
            //             $(_slick.$slideTrack).css('transition','');
            $(_slider).slick("slickSetOption", "speed", 1000);
          }
        }, 250);
        return;
      }

      $(_slider).attr("data-in-count", 0);
      if (!$(_slider).hasClass("_funcCalled")) {
        startSlider($(this));
      }
    }
  );

  /*$(document).on('mouseleave','.scrollable-image-slider .slick-arrow:not(.slick-disabled)',function(e){
    e.preventDefault(); var _count = 0, _this = $(this); });*/

  function startSlider(_this) {
    var _slider = _this.closest(".slick-initialized"),
      _count,
      _timeout = window.innerWidth > 767 ? 1500 : 3000;
    _count = Number($(_slider).attr("data-in-count") || 0);
    console.log("_count ", _count);

    if (_count > 2) {
      var _slick = $(_slider)[0].slick;
      $(_slider)
        .find(".slick-arrow")
        .removeAttr("data-customplay")
        .removeClass("clicked");
      $(_slider).removeClass("stopAutoPlay");
      $(_slider).slick(
        "slickSetOption",
        "speed",
        Number($(_slider).attr("data-speed"))
      );
      $(_slider).slick("slickSetOption", "waitForAnimate", true);
      $(_slider).slick("slickSetOption", "useCSS", true);
      $(_slider).slick("slickPlay");
      clearInterval(sliderInterval);
      $(_slider).removeClass("_funcCalled");
      $(_slider).removeAttr("data-in-count");
    } else {
      $(_slider).addClass("_funcCalled");
      _count = _count + 1;
      $(_slider).attr("data-in-count", _count);

      setTimeout(function () {
        startSlider(_this);
      }, _timeout);
    }
    return;
  }

  //eneable magnific popup gallery
  galleryIntialize();
}

function galleryIntialize() {
  $(".scrollable-image .popup-gallery").each(function () {
    $(this)
      .find("a")
      .magnificPopup({
        type: "image",
        callbacks: {
          beforeOpen: function () {
            $("body").addClass("scrollableImageBody");
          },
          afterClose: function () {
            $("body").removeClass("scrollableImageBody");
          },
          elementParse: function (item) {
            // Function will fire for each target element
            // "item.el[0]" is a target DOM element (if present)
            // "item.src" is a source that you may modify
            //console.log('type--',item.el[0].dataset.type);
            if (item.el[0].dataset.type == "video") {
              (item.type = "iframe"),
                (item.iframe = {
                  patterns: {
                    youtube: {
                      index: "youtube.com/", // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).

                      id: "v=", // String that splits URL in a two parts, second part should be %id%
                      // Or null - full URL will be returned
                      // Or a function that should return %id%, for example:
                      // id: function(url) { return 'parsed id'; }

                      src: "//www.youtube.com/embed/%id%?autoplay=1", // URL that will be set as a source for iframe.
                    },
                    vimeo: {
                      index: "vimeo.com/",
                      id: "/",
                      src: "//player.vimeo.com/video/%id%?autoplay=1",
                    },
                    gmaps: {
                      index: "//maps.google.",
                      src: "%id%&output=embed",
                    },
                  },
                });
            } else {
              (item.type = "image"),
                (item.tLoading = "Loading image #%curr%..."),
                (item.mainClass = "mfp-img-mobile"),
                (item.image = {
                  tError:
                    '<a href="%url%">The image #%curr%</a> could not be loaded.',
                });
            }
          },
        },
        gallery: {
          enabled: true,
          navigateByImgClick: false,
          preload: [0, 1], // Will preload 0 - before current, and 1 after the current image
        },
      });
  });
}

function homeTestimonialSlider() {
  var testimonialAutoPlaySpeed = parseInt(
    $(".testimonial-slider").attr("data-slider-speed")
  );
  $(".testimonial-slider").slick({
    infinite: true,
    slidesToShow: 1,
    centerMode: true,
    dots: false,
    autoplay: true,
    autoplaySpeed: testimonialAutoPlaySpeed,
    arrows: false,
    responsive: [
      {
        breakpoint: 750,
        settings: {
          centerMode: false,
        },
      },
    ],
  });
}

function productImagesSlider() {
  var slideToShow = 2;
  var hasInfinite = true;
  var slideCount = parseInt(
    $(".main-product-section .thumb_slider_new").attr("data-slide-count")
  );
  if (slideCount > 4) {
    slideToShow = 4;
  } else if (slideCount == 4) {
    slideToShow = 3;
    $(".main-product-section .thumb_slider_new").addClass("three__slide");
  } else if (slideCount == 2) {
    slideToShow = 1;
    hasInfinite = false;
    $(".main-product-section .thumb_slider_new").addClass("one__slide");
  } else {
    slideToShow = 2;
    $(".main-product-section .thumb_slider_new").addClass("two__slide");
  }

  $(".main-product-section .main_slider_new").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: ".main-product-section .thumb_slider_new",
  });
  $(".main-product-section .thumb_slider_new").slick({
    slidesToShow: slideToShow,
    slidesToScroll: 1,
    asNavFor: ".main-product-section .main_slider_new",
    arrows: true,
    focusOnSelect: true,
    infinite: hasInfinite,
  });

  //   $('.main-product-section .thumb_slider_new').on('afterChange', function(event, slick, currentSlide){
  //     if($(this).find(".slick-current").hasClass('has__video')){
  //       let dataTarget = $(this).find(".slick-current").attr('data-target');
  //       $(this).find(".slick-current").find('.thumbnail-box').trigger('click');
  //       //document.querySelector('media-gallery').setActiveMedia(dataTarget, false);
  //     }
  //   });
  $(".main-product-section .thumb_slider_new .slick-arrow").on(
    "click",
    function (event) {
      $(this)
        .closest(".thumb_slider_new")
        .find(".slick-current")
        .find(".thumbnail-box")
        .trigger("click");
    }
  );
}

/* membership template scrollTo section */
$(document).on(
  "click",
  ".scrollTo-div .scrollTo-item a.scrollTo-link",
  function (e) {
    e.preventDefault();
    var _id = $(this).attr("href");
    var _headerHeight =
      $(".section-header sticky-header.header-wrapper").outerHeight(true) || 0;
    $([document.documentElement, document.body]).animate(
      {
        scrollTop: $(_id).offset().top - _headerHeight,
      },
      1000
    );
  }
);
/* membership template scrollTo section */

/*
======================================================
Below Javascript will be executed only on editor mode
Place this script always at bottom
*This will only render in the theme editor*
======================================================
*/
window.addEventListener("DOMContentLoaded", (e) => {
  if (Shopify.designMode) {
    document.addEventListener("shopify:section:load", function (event) {
      const homeSlideShowSection =
        event.target.querySelector(".slideshow__slider") || null;
      if (
        homeSlideShowSection &&
        !homeSlideShowSection.classList.contains("slick-initialized")
      ) {
        homeSlideShowSlider();
      }

      const homeScrollableImgSection =
        event.target.querySelector(".scrollable-image-slider") || null;
      if (
        homeScrollableImgSection &&
        !homeScrollableImgSection.classList.contains("slick-initialized")
      ) {
        homeScrollableImgSlider();
      }

      const homeTestimonialSection =
        event.target.querySelector(".testimonial-slider") || null;
      if (
        homeTestimonialSection &&
        !homeTestimonialSection.classList.contains("slick-initialized")
      ) {
        homeTestimonialSlider();
      }

      const productImagesSliderSection =
        event.target.querySelector(".main-product-section") || null;
      if (
        productImagesSliderSection &&
        !productImagesSliderSection
          .querySelector(".main_slider_new")
          .classList.contains("slick-initialized")
      ) {
        productImagesSlider();
      }
    });
  }
});

/*====================================================*/


document.querySelectorAll('.tool-tip-box').forEach((tooldata) => {
  tooldata.addEventListener('mouseenter', function () {
    tooldata.closest('.filters-box-row-wrap').classList.add('active-tooltip');
  })

  tooldata.addEventListener('mouseleave', function () {
    tooldata.closest('.filters-box-row-wrap').classList.remove('active-tooltip');
  })

})